import { Box, Card, CardContent, Skeleton, Typography } from "@mui/material";

function Variacao({ variation, invert }) {
  if (variation === null || variation === undefined) return null;
  const neutro = variation === 0;
  const bom = invert ? variation < 0 : variation > 0;
  const cor = neutro ? "#94a3b8" : bom ? "#16a34a" : "#dc2626";
  const seta = neutro
    ? "ph-minus"
    : variation > 0
    ? "ph-trend-up"
    : "ph-trend-down";
  return (
    <Box display="flex" alignItems="center" gap={0.3} sx={{ mt: 0.2 }}>
      <i className={`ph-bold ${seta}`} style={{ color: cor, fontSize: 11 }} />
      <Typography sx={{ color: cor, fontWeight: 600, fontSize: 10.5 }}>
        {variation > 0 ? "+" : ""}
        {variation}%
      </Typography>
      <Typography sx={{ color: "text.disabled", fontSize: 10.5 }}>
        vs. anterior
      </Typography>
    </Box>
  );
}

function KpiCardSkeleton() {
  return (
    <Card sx={{ borderRadius: 3, border: "1px solid #f0f0f0", height: "100%" }}>
      <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
        <Box display="flex" alignItems="center" gap={1.5}>
          <Skeleton variant="rounded" width={46} height={46} />
          <Box sx={{ flex: 1 }}>
            <Skeleton width="60%" height={28} />
            <Skeleton width="80%" height={16} />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}

const KpiCard = ({
  title,
  value,
  subtitle,
  icon,
  color,
  variation,
  invert,
  loading,
}) => {
  if (loading) return <KpiCardSkeleton />;
  return (
    <Card
      className="d-flex align-items-center h-100"
      sx={{
        borderRadius: 3,
        border: "1px solid #f0f0f0",
        transition: "box-shadow 0.2s",
        p: 2,
        "&:hover": { boxShadow: "0 4px 20px rgba(0,0,0,0.08)" },
      }}
    >
      <Box display="flex" alignItems="center" gap={1.5}>
        <Box
          sx={{
            width: 46,
            height: 46,
            borderRadius: 2,
            backgroundColor: `${color}18`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <i className={`ph-bold ${icon}`} style={{ color, fontSize: 22 }} />
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography
            variant="h5"
            sx={{ fontWeight: 700, lineHeight: 1.1, color: "#1e293b" }}
          >
            {value}
          </Typography>
          <Typography
            variant="caption"
            sx={{ color: "text.secondary", fontWeight: 500 }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography
              variant="caption"
              title={subtitle}
              sx={{
                display: "block",
                color: "text.disabled",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {subtitle}
            </Typography>
          )}
          <Variacao variation={variation} invert={invert} />
        </Box>
      </Box>
    </Card>
  );
};

export default KpiCard;
